<div class="fixed flex items-center gap-2 p-4 z-10 top-40 right-0 border foreground border-color rounded-l-lg">
  <l-spinner size="sm" />
</div>
